import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesOrderList {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        // webcontext.ConfigName = '';
        webcontext.ResponseMessage.Success = true;
        if(webcontext.Account.Id !="00000000-0000-0000-0000-000000000000"){
            webcontext.RequestBody =JSON.stringify({"a_FK_SystemUser_Create_ID":webcontext.Account.Id});
            webcontext.ResponseMessage.ErrorMessage = "成功";
        }
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        return webContext;
    }
}